import { isMobile, isTablet } from 'react-device-detect';
import { sanitize } from './sanitize';

const getDeviceType = () => {
    if (isTablet) return 'tablet';
    if (isMobile) return 'mobile';
    return 'desktop';
};

export const getStaticDeviceProfile = () =>
    sanitize({
        device_type: getDeviceType(),
        screen_w: window.screen?.width,
        screen_h: window.screen?.height,
        dpr: window.devicePixelRatio,
        device_memory_gb: navigator.deviceMemory,
        cpu_cores: navigator.hardwareConcurrency,
    });

// Network Information API: Chromium only, and its values change during a journey.
export const getDynamicProfile = () => {
    const connection = navigator.connection;

    return sanitize({
        network_type: connection?.effectiveType,
        downlink_mbps: connection?.downlink,
        rtt_ms: connection?.rtt,
        save_data: connection?.saveData,
    });
};

// UA client hints only report a model on Android Chromium; elsewhere this resolves to undefined.
export const getDeviceModel = async () => {
    try {
        const hints = await navigator.userAgentData?.getHighEntropyValues(['model']);

        return hints?.model || undefined;
    } catch {
        return undefined;
    }
};
